module.exports = __webpack_public_path__ + "static/img/103434.54257c21.png";